// extracted by mini-css-extract-plugin
export default {"button":"TabComponent_button__06J+C","title":"TabComponent_title__s0eWt","activeTitle":"TabComponent_activeTitle__Olbax"};